import React,{ createContext,useState } from 'react';
import { FormToFilling,ItemFormFilling,SubItemFormFilling } from '../types/new-form-filling/types';

const initialSubItem: SubItemFormFilling = {
  id: 0,
  new_id: '', // eslint-disable-line
  itemid: '',
  nome: '',
  tipo: 'avaliacao',
  // visuais
  changes: false,
  // configuração
  ocorrenciaPreenchido: false,
  comentarioPreenchido: false,
  fotoPreenchido: false,
  comentario: false,
  foto: false,
  galeriaFoto: false,
  permiteArquivo: false,
  padrao: null,
  validacao: null,
  obrigatoriedade: {
    conforme: {
      img: false,
      ocorrencia: false,
      obrigaArquivo: false,
    },
    naoConforme: {
      img: false,
      ocorrencia: false,
      obrigaArquivo: false,
    },
    NA: {
      img: false,
      ocorrencia: false,
      obrigaArquivo: false,
    }, //eslint-disable-line
    preenchimento: false,
    ocorrencia: false,
    img: false,
    obrigaArquivo: false,
  },
  help: {
    foto: '',
    video: '',
    choose: '',
    comentario: '',
  },
  hasHelp: false,
  status: 'vazio',

  // lista
  padraoLista: [],

  // numero
  maxNumberVal: 0,
  minNumberVal: 0,
  noDecimal: false,

  // controle
  // checked: null,

  // avaliação
  // avaliacao:  [{ valor: 0, nome: '', NA: null }], // eslint-disable-line
  // nota: null,
  // threshold: null,
  // peso: null,

  // seleção múltipla
  selecao: [],
  selecionados: [{
    texto: '',
    // cssClass: {
    //   preenchido: false,
    //   erro: false,
    // }
  }],
  temSelecionado: false,
  padraoMultiple: null,

  // assinatura
  assinatura: '',

  // textos
  ocorrencia: '',
  obs: '',

  // fotos
  img: [],

  // chamados
  limiteChamado: 0,
  tipoChamado: [{
    id: "",
    message: '',
    nome: '',
    tipo: '',
    emails: [],
    selecionado: null,
    remetente: '',
    prazo: 0,
    prazoHoras: 0,
  }],
  tempChamado: 0,
  chamados: [
    {
      selecionado: {
        id: "",
        message: '',
        nome: '',
        tipo: '',
        emails: [],
        selecionado: null,
        remetente: '',
        prazo: 0,
        prazoHoras: 0,
      },
      dateChamado: new Date(),
      textChamado: '',
      selKey: 0 || '' || null,
      shown: false,
      dateTime: '',
      statusChamado: '',
      statusPrazo: '',
    }
  ],
  chamadoObrigatorio: '',
  chamadoRed: false,

  // notificações
  tipoNotificacao: {
    id: 0,
    notificar: ''
  },

  // corAvl?: string,
  statusOcorrencia: '',
  statusObservacao: '',
  statusFoto: '',
  statusChamado: '',
  countItem: 0,
  icon: '',
  inputType: '',
  noAnim: false,
  shown: false,
  shownHelp: false,
  tempISODate: '',
  corSubHeader: '',

  // scoring
  valorScoring: 0,
  valorMaxScoring: 0,

  // hides
  hideImg: false,
  hideComent: false,

  // templates
  opcoes: [],
  opcoesEscolhidas: [],
  conformidade: '',
};

const initialItem: ItemFormFilling = {
  id: "",
  nome: "",
  peso: 0,
  subitens: [initialSubItem],
};

const initialState: FormToFilling = {
  usuario: '',
  aprovacao: {
    aprovadores: [''],
    status: "",
  },
  chamadoObrigatorio: false,
  cliente: "",
  conjunto: "",
  editavel: {
    cancela: false,
    clone: false
  },
  empresa: "",
  fim: 0,
  gerencia: "",
  id: "",
  identificadorLista: "",
  inicio: 0,
  itens: [initialItem],
};

export const WebFormContext = createContext<{
  webForm: FormToFilling,
  setWebForm: Function,
  fotos: File[],
  setFotos: Function,
  arquivos: File[],
  setArquivos: Function,
  changeValue: boolean,
  setChangeValue: Function,
  ForceUpdate: Function,
}>({
  webForm: initialState,
  setWebForm: () => { },
  fotos: [],
  setFotos: () => { },
  arquivos: [],
  setArquivos: () => { },
  changeValue: false,
  setChangeValue: () => { },
  ForceUpdate: () => { },
});
export default function WebFormProvider({ children }: { children: React.ReactNode }) {
  const [webForm, setWebForm] = useState<FormToFilling>(initialState);
  const [fotos, setFotos] = useState<File[]>([]);
  const [arquivos, setArquivos] = useState<File[]>([]);
  const [changeValue, setChangeValue] = useState(false);

  function ForceUpdate() {
    setChangeValue(!changeValue);
  }

  const store = {
    webForm,
    setWebForm,
    fotos,
    setFotos,
    arquivos,
    setArquivos,
    changeValue,
    setChangeValue,
    ForceUpdate,
  };
  return (
    <WebFormContext.Provider value={store}>
      {children}
    </WebFormContext.Provider>
  );
}